import React from "react";
import styled from "styled-components";
import { OffScreenStyles } from "./../../ui/components/mixins";

const ResultsContainer = styled.div`
  ${props => (props.result ? null : OffScreenStyles)};
`;

// Announce updated results to screen readers
const AccessibleSearchResults = ({ total, result, className }) => {
  return (
    <ResultsContainer
      aria-live="polite"
      aria-atomic="true"
      className={className}
      result={result}
      role="status"
    >
      {result || i18n.pluralize(
        total,
        "header.search.one-result",
        "header.search.many-results"
      )}
    </ResultsContainer>
  );
};

export default AccessibleSearchResults;
